var path = '/app/components/form/plans-clear-button/plans-clear-button.html';
var html = "<button type=submit class=\"btn btn-info pull-left\" ng-click=$ctrl.onAccept()> {{'action.clear' | translate}} </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;